module.exports = __webpack_public_path__ + "media/images/mail/ico-line-8e3e517c60b6847cb6756c55b13969d0.png";